import axios from 'axios';
import { ROOT_URL_V2, getCSRFToken } from '../config';
import { toggleModal, toggleSuccessMessage } from './ViewController';
import { updateLoading } from './Loading';
import actions from '../actions';
// eslint-disable-next-line import/no-cycle
import { minStartTimeAsync, updateField } from './BookingRequest';
import { fetchServicesStructureAsync } from './ServicesStructure';
import { modalTypes } from '../consts';
import { executeHttpRequest } from '../epics/api';
import { getNotificationCounterQuery } from '../components/operations/notifications/settings';

export const FETCH_LOGGED_IN = 'FETCH_LOGGED_IN';
export const FETCH_SIGNED_UP = 'FETCH_SIGNED_UP';
export const FETCH_CLIENT_DATA = 'FETCH_CLIENT_DATA';
export const FETCH_USER_DATA = 'FETCH_USER_DATA';
export const FETCH_USER_TYPE = 'FETCH_USER_TYPE';
export const FETCH_POSTCODE_ADDRESS_LIST = 'FETCH_POSTCODE_ADDRESS_LIST';
export const FETCH_CLIENT_ADDRESS_LIST = 'FETCH_CLIENT_ADDRESS_LIST';
export const FETCH_PAYMENT_METHODS = 'FETCH_PAYMENT_METHODS';
export const CLEAR_PAYMENT_METHODS = 'CLEAR_PAYMENT_METHODS';
export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const ADD_ADDRESS = 'ADD_ADDRESS';
export const REMOVE_ADDRESS = 'REMOVE_ADDRESS';
export const FETCH_BUZZ_WORKERS = 'FETCH_BUZZ_WORKERS';
export const FETCH_CUSTOMERS = 'FETCH_CUSTOMERS';


export function fetchClientData(data) {
    return {
        type: FETCH_CLIENT_DATA,
        payload: data,
    };
}

export function fetchClientAddressList(data) {
    return {
        type: 'FETCH_CLIENT_ADDRESS_LIST',
        payload: data,
    };
}

export function fetchClientAddressListAsync(clientId, completion) {
    return dispatch => {
        dispatch(updateLoading('clientAddress', true));
        axios({
            method: 'GET',
            url: `${ROOT_URL_V2}clients/${clientId}/addresses/`,
        })
            .then(response => {
                const addresses = Array.isArray(response.data.content)
                    ? response.data.content
                    : [];
                dispatch(fetchClientAddressList(addresses));
                dispatch(updateLoading('clientAddress', false));
                if (completion) {
                    completion(addresses);
                }
            })
            .catch(error => {
                dispatch(updateLoading('clientAddress', false));
                // eslint-disable-next-line no-console
                console.log(error.response);
            });
    };
}

export function fetchClientLoggedInAsync(userData, completion) {
    return dispatch => {
        axios({
            method: 'get',
            url: `${ROOT_URL_V2}clients/me/`,
        })
            .then(response => {
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                dispatch(fetchLoggedIn(true));
                dispatch(toggleModal('authModal', null));
                dispatch(fetchClientData(response.data.content));
                dispatch(actions.clientLoggedIn(response.data.content));
                dispatch(updateField('admin_information', response.data.content.default_admin_information));
                dispatch(updateField('freelancers_information', response.data.content.default_freelancer_information));
                completion(userData, undefined);
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log('fetchClientLoggedInAsync-error', error.response);
                completion(undefined, error.response);
            });
    };
}

export function fetchClientDataForSelfManaged(completion) {
    return dispatch => {
        axios({
            method: 'get',
            url: `${ROOT_URL_V2}clients/`,
        })
            .then(response => {
                dispatch(fetchClientData(response.data.content[0]));
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                dispatch(
                    updateField(
                        'admin_information',
                        response.data.content[0].default_admin_information,
                    ),
                );
                dispatch(
                    updateField(
                        'freelancers_information',
                        response.data.content[0].default_freelancer_information,
                    ),
                );
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(
                    'fetchClientDataForSelfManaged-error',
                    error.response,
                );
                completion(undefined, error.response);
            });
    };
}

export function addClientAddress(data) {
    return {
        type: 'ADD_ADDRESS',
        payload: data,
    };
}

export function removeClientAddress(data) {
    return {
        type: 'REMOVE_ADDRESS',
        payload: data,
    };
}

export function removeClientAddressAsync(data) {
    return dispatch => {
        dispatch(removeClientAddress(data));
        if (data.url) {
            axios({
                method: 'DELETE',
                url: data.url,
                headers: {
                    'X-CSRFToken': getCSRFToken(),
                },
            });
        }
    };
}

export function errorMessage(field, message) {
    return {
        type: 'ERROR_MESSAGE',
        payload: { field, message },
    };
}

export function fetchPostcodeAddressList(data) {
    return {
        type: 'FETCH_POSTCODE_ADDRESS_LIST',
        payload: data,
    };
}

export function fetchPostcodeAddressListAsync(postcode, completion) {
    return dispatch => {
        executeHttpRequest(
            `postcode-addresses/${postcode}/`,
            'get'
        )
            .then(response => {
                dispatch(fetchPostcodeAddressList(response.data));
                completion(response.data, undefined);
            })
            .catch(error => {
                completion(undefined, error.response);
            });
    };
}

export function checkValidPostcode(postcode, completion) {
    return dispatch => {
        dispatch(updateLoading('postcode', true));

        axios({
            method: 'POST',
            url: `${ROOT_URL_V2}paygrades/valid-postcodes/`,
            data: { postcode },
            headers: {
                'X-CSRFToken': getCSRFToken(),
            },
        })
            .then(response => {
                dispatch(errorMessage('postcode', null));
                if (response.data.content.valid) {
                    dispatch(
                        // eslint-disable-next-line no-shadow
                        fetchPostcodeAddressListAsync(
                            postcode,
                            (resp, error) => {
                                dispatch(updateLoading('postcode', false));
                                completion(resp, error);
                            },
                        ),
                    );
                }
            })
            .catch(error => {
                dispatch(
                    errorMessage('postcode', error.response.data?.meta.detail),
                );
                completion(undefined, error.response);
                dispatch(updateLoading('postcode', false));
            });
    };
}

export function checkValidPostcodeWithoutFetchingPostcodeList(postcode) {
    return dispatch => {
        dispatch(updateLoading('postcode', true));

        axios({
            method: 'POST',
            url: `${ROOT_URL_V2}paygrades/valid-postcodes/`,
            data: { postcode },
            headers: {
                'X-CSRFToken': getCSRFToken(),
            },
        })
            .then(() => {
                dispatch(errorMessage('postcode', null));
            })
            .catch(error => {
                dispatch(
                    errorMessage('postcode', error.response.data.meta.detail),
                );
            })
            .finally(() => {
                dispatch(updateLoading('postcode', false));
            });
    };
}

export function setPaymentMethods(data) {
    return {
        type: 'FETCH_PAYMENT_METHODS',
        payload: data.content,
    };
}

export function clearPaymentMethods() {
    return {
        type: 'CLEAR_PAYMENT_METHODS',
        payload: undefined,
    };
}

// default comment info == http://127.0.0.1:8000/api/v1/client 'default_admin_information'

export function fetchPaymentMethods(clientId, status = '') {
    return dispatch => {
        dispatch(updateLoading('clientPaymentMethods', true));
        axios({
            method: 'GET',
            // eslint-disable-next-line max-len
            url: `${ROOT_URL_V2}clients/${clientId}/payment-methods/${
                status ? `?status=${status}` : ''
            }`,
        })
            .then(response => {
                dispatch(setPaymentMethods(response.data));
                dispatch(updateLoading('clientPaymentMethods', false));
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error);
                dispatch(updateLoading('clientPaymentMethods', false));
            });
    };
}

export function checkValidVoucherCode(voucherCode, completion) {
    return () => {
        axios({
            method: 'get',
            url: `${ROOT_URL_V2}vouchers/${encodeURIComponent(voucherCode)}/`,
        })
            .then(response => {
                completion(response.data, undefined);
            })
            .catch(error => {
                completion(undefined, error.response);
            });
    };
}

/* Reset Password */

export function resetPassword(data, completion) {
    return dispatch => {
        axios({
            method: 'POST',
            url: `${ROOT_URL_V2}user/reset-password/`,
            data,
            withCredentials: false,
        })
            .then(response => {
                dispatch(toggleSuccessMessage(response.data.meta.success));
                dispatch(toggleModal('authModal', modalTypes.LOGIN));
            })
            .catch(error => {
                completion(undefined, error.response);
            });
    };
}

/* Login & Signup */

export function fetchLoggedIn(data) {
    return {
        type: 'FETCH_LOGGED_IN',
        payload: data,
    };
}

export function fetchSignedUp(data) {
    return {
        type: 'FETCH_SIGNED_UP',
        payload: data,
    };
}

export function fetchUserType(data) {
    //= ==================================================
    // TODO Integration this was blocking the integration
    //
    // if (data == 'freelancer' || data == 'admin') {
    //     window.location = SERVER_URL;
    // }
    return {
        type: 'FETCH_USER_TYPE',
        payload: data,
    };
}

export function fetchUserData(data) {
    return {
        type: 'FETCH_USER_DATA',
        payload: data,
    };
}

export function fetchLoggedInAsync(completion) {
    return dispatch => {
        dispatch(minStartTimeAsync());
        dispatch(fetchServicesStructureAsync());
        axios({
            method: 'get',
            url: `${ROOT_URL_V2}user/`,
        })
            .then(response => {
                const userType = response.data.content.user_type;
                const userData = response.data;
                dispatch(fetchUserType(userType));
                dispatch(fetchUserData(userData));
                dispatch(actions.authenticatedUser(userData));
                // Load user notifications
                dispatch(
                    actions.loadNotificationsCounters(
                        getNotificationCounterQuery(userType),
                    ),
                );
                //= ==================================================
                // TODO Integration this was blocking the integration
                if (userType === 'client') {
                    dispatch(fetchClientLoggedInAsync(userData, completion));
                } else if (userType === 'agent') {
                    if (response.data.content.agency_detail.features.indexOf('booking_tunnel')) {
                        dispatch(fetchClientDataForSelfManaged(completion));
                    }
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    dispatch(processAgentLoggedIn(userData, completion));
                } else {
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    dispatch(freelancerLoggedIn(completion));
                }
            })
            .catch(error => {
                completion(undefined, error.response);
            });
    };
}

export function processAgentLoggedIn(userData, completion) {
    // TODO Get Admin details
    return dispatch => {
        dispatch(fetchLoggedIn(true));
        dispatch(actions.agentLoggedIn(userData));
        dispatch(toggleModal('authModal', null));
        completion(userData, undefined);
    };
}

export function freelancerLoggedIn(completion) {
    // TODO Get freelancer details
    return dispatch => {
        dispatch(fetchLoggedIn(true));
        dispatch(toggleModal('authModal', null));
        completion({}, undefined);
    };
}

export function login(data, completion) {
    return dispatch => {
        const payload = Object.fromEntries(
            Object.entries(data)
                .map(([key, value]) => [key, value.trim()])
                .filter(([, value]) => value !== '')
        );
        axios({
            method: 'POST',
            url: `${ROOT_URL_V2}user/login/?withsession=1`,
            data: payload,
        })
            .then(response => {
                if (response.status === 202) {
                    // Handle MFA challenge
                    completion(response, undefined);
                } else {
                    dispatch(fetchLoggedInAsync(completion));
                }
            })
            .catch(error => {
                completion(undefined, error.response);
            });
    };
}

export function signup(data, rawData, completion) {
    return dispatch => {
        axios({
            method: 'POST',
            url: `${ROOT_URL_V2}clients/`,
            data,
        })
            .then(() => {
                const loginData = {
                    username: rawData.email,
                    password: rawData.password,
                };
                dispatch(fetchSignedUp(true));
                dispatch(login(loginData, completion));
            })
            .catch(error => {
                completion(undefined, error.response);
            });
    };
}

export function logout() {
    return dispatch => {
        dispatch(fetchLoggedIn(false));
        dispatch(actions.userLoggedOut(false));
        dispatch(toggleModal('authModal', 'login'));
    };
}

export function checkEmail(email, completion) {
    const data = { email };
    axios({
        method: 'post',
        url: `${ROOT_URL_V2}user/valid-email/`,
        data,
    })
        .then(response => {
            completion(response.data.content, undefined);
        })
        .catch(error => {
            completion(undefined, error.response);
        });
}

export function fetchBuzzWorkers(data) {
    return {
        type: 'FETCH_BUZZ_WORKERS',
        payload: data,
    };
}

export function fetchBuzzWorkersAsync() {
    return dispatch => {
        axios({
            method: 'get',
            url: `${ROOT_URL_V2}freelancers/?extract=1`,
        })
            .then(response => {
                if (response.data)
                    dispatch(fetchBuzzWorkers(response.data.content));
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log('fetchBuzzWorkersAsync-error', error.response);
            });
    };
}

export function fetchCustomers(data) {
    return {
        type: 'FETCH_CUSTOMERS',
        payload: data,
    };
}

export function fetchCustomersAsync() {
    return dispatch => {
        axios({
            method: 'get',
            url: '/static/customers.json',
        }).then(response => {
            dispatch(fetchCustomers(response.data));
        });
    };
}
